import React from 'react'
import { useGLTF, Outlines } from '@react-three/drei'
import modelUrl from './assets/models/small_coffee_shop-transformed.glb'

export function CoffeeShopSimpleOutline({ showOutline = false, thickness = 0.8, color = "#35c19f", angle = 0, onClick, onPointerOver, onPointerOut, ...props }) {
  const { nodes, materials } = useGLTF(modelUrl)

  // Only add outline to main building parts, not small details
  const MainOutline = showOutline ? (
    <Outlines
      thickness={thickness}
      color={color}
      angle={angle}
    />
  ) : null

  return (
    <group {...props} dispose={null}>
      {/* Non-interactive meshes - no event handlers */}
      <mesh geometry={nodes.Object_4.geometry} material={materials.Tiles_Old} position={[-0.49, 0.039, -0.217]} rotation={[0, -1.449, 0]} scale={0.018} />
      <mesh geometry={nodes.Object_33.geometry} material={materials.Cofffee_Font} position={[0, -0.011, 0]} />

      {/* Main building structure with single click handler on group */}
      <group
        onClick={(e) => {
          e.stopPropagation()
          if (onClick) onClick(e)
        }}
        onPointerOver={(e) => {
          e.stopPropagation()
          if (onPointerOver) onPointerOver(e)
        }}
        onPointerOut={(e) => {
          e.stopPropagation()
          if (onPointerOut) onPointerOut(e)
        }}
      >
        {/* Main structure meshes only - with outline */}
        <mesh geometry={nodes.Object_41.geometry} material={materials.Coffee_Roofs} position={[0, -0.011, 0]}>
          {MainOutline}
        </mesh>
        <mesh geometry={nodes.Object_45.geometry} material={materials.Coffee_Roof} position={[0.031, 1.697, -0.118]} scale={0.768}>
          {MainOutline}
        </mesh>
        <mesh geometry={nodes.Object_39.geometry} material={materials.Coffee_BaseEdges} position={[0.031, -0.013, -0.118]} scale={0.778}>
          {MainOutline}
        </mesh>

        {/* All other meshes without individual outlines for performance */}
        <mesh geometry={nodes.Object_6.geometry} material={materials.PaletteMaterial001} position={[0.716, 1.132, -0.331]} scale={0.188} />
        <mesh geometry={nodes.Object_7.geometry} material={materials.PaletteMaterial002} position={[0.716, 1.132, -0.331]} scale={0.188} />
        <mesh geometry={nodes.Object_12.geometry} material={materials.PaletteMaterial003} position={[-0.693, 1.709, 0.423]} scale={0.133} />
        <mesh geometry={nodes.Object_24.geometry} material={materials.coffee} position={[0.701, 2.096, -1.676]} scale={0.144} />
        <mesh geometry={nodes.Object_35.geometry} material={materials.Coffee_Tables} position={[0.72, 0.878, -0.508]} rotation={[-Math.PI, 0, -Math.PI]} scale={0.778} />
        <mesh geometry={nodes.Object_37.geometry} material={materials.Coffee_Menu} position={[1.143, 1.194, 0.964]} rotation={[-Math.PI, 0, -Math.PI]} scale={[0.778, 0.72, 0.778]} />
        <mesh geometry={nodes.Object_43.geometry} material={materials.Coffee_Poles} position={[-0.907, 1.88, -2.03]} rotation={[-0.003, 0, 0.435]} scale={0.015} />
        <mesh geometry={nodes.Object_47.geometry} material={materials.Coffee_cages} position={[0, -0.011, 0]} />
        <mesh geometry={nodes.Object_49.geometry} material={materials['Coffee_Floor.001']} position={[0.031, -0.009, -0.118]} scale={0.778} />
        <mesh geometry={nodes.Object_51.geometry} material={materials.material} position={[-0.989, 2.043, 0.811]} scale={[0.048, 0.063, 0.072]} />
        <mesh geometry={nodes.Object_53.geometry} material={materials.Coffee_Heater} position={[0, -0.011, 0]} />
        <mesh geometry={nodes.Object_55.geometry} material={materials.Coffee_misc} position={[-0.786, 0.969, -1.869]} rotation={[0, -1.449, 0]} scale={0.055} />
        <mesh geometry={nodes.Object_57.geometry} material={materials.Coffee_Brewer} position={[-0.786, 0.969, -1.869]} rotation={[0, -1.449, 0]} scale={0.055} />
        <mesh geometry={nodes.Object_59.geometry} material={materials.Coffee_Shelfs} position={[-0.786, 0.969, -1.869]} rotation={[0, -1.449, 0]} />
        <mesh geometry={nodes.Object_61.geometry} material={materials.Coffee_Drinks} position={[0.628, 1.516, -1.087]} rotation={[0, -1.449, 0]} />
        <mesh geometry={nodes.Object_63.geometry} material={materials.Coffee_cakes} position={[0, -0.011, 0]} />
        <mesh geometry={nodes.Object_65.geometry} material={materials.Coffee_misc2} position={[-0.886, 1.545, -1.58]} rotation={[0, -0.312, 0]} />
        <mesh geometry={nodes.Object_73.geometry} material={materials.Crossiant} position={[-0.788, 1.334, 0.831]} rotation={[-1.098, -0.071, 1.432]} scale={1.516} />
        <mesh geometry={nodes.Object_75.geometry} material={materials.Metal} position={[-0.693, 1.569, -1.506]} rotation={[0, -1.263, 0]} scale={0.032} />
        <mesh geometry={nodes.Object_76.geometry} material={materials.Body} position={[-0.693, 1.569, -1.506]} rotation={[0, -1.263, 0]} scale={0.032} />
        <mesh geometry={nodes.Object_78.geometry} material={materials.Normal} position={[-0.656, 1.525, -1.603]} rotation={[-Math.PI / 2, 0, 1.596]} scale={0.583} />
        <mesh geometry={nodes.Object_80.geometry} material={materials.Cake} position={[0.682, 1.31, 0.722]} rotation={[0.918, -0.081, 0.101]} scale={0.044} />
        <mesh geometry={nodes.Object_82.geometry} material={materials.Cake_icing} position={[0.746, 1.276, 0.225]} rotation={[0.51, 0.753, -0.668]} scale={0.044} />
        <mesh geometry={nodes.Object_85.geometry} material={materials.Allcookies} position={[0.771, 1.877, 0.701]} rotation={[0.334, -0.203, 0.256]} scale={0.034} />
        <mesh geometry={nodes.Object_91.geometry} material={materials.cookies1} position={[0.685, 1.557, 0.451]} rotation={[-0.627, -0.184, 0.802]} scale={[-0.039, 0.058, 0.039]} />
        <mesh geometry={nodes.Object_111.geometry} material={materials.Bigcake} position={[0.682, 1.297, -0.064]} rotation={[-3.133, -0.499, -3.141]} scale={[0.021, 0.014, 0.021]} />
        <mesh geometry={nodes.Object_115.geometry} material={materials.cake1} position={[0.436, 1.168, -0.355]} rotation={[0.014, -0.057, 0.026]} scale={0.093} />
      </group>
    </group>
  )
}

useGLTF.preload(modelUrl)